import type { IconProps } from '../create-icon'

// The Overwatch emblem alone (no "2" badge), single colour: it takes `color`.
// From Wikimedia Commons "File:Overwatch 2 logo.svg" — public domain as a
// drawing; the mark itself is Blizzard's trademark.
export function OverwatchLogo({
  size = 24,
  color = 'currentColor',
  className,
  style,
  ...rest
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 36.3 36.3"
      fill={color}
      className={className}
      style={style}
      {...rest}
    >
      <path d="M18.15 5.18a13 13 0 0 1 8.51 3.19l3.67-3.67A18.15 18.15 0 0 0 6 4.7l3.63 3.67a13 13 0 0 1 8.52-3.19z" />
      <path d="M31.43 5.78l-3.67 3.67a13 13 0 0 1 1.7 15l-7.27-7-3.28-7.9v11.89l7.2 6.93a12.95 12.95 0 0 1-15.93 0l7.2-6.93V9.55l-3.28 7.92-7.27 7a13 13 0 0 1 1.7-15L4.86 5.78a18.15 18.15 0 1 0 26.57 0z" />
    </svg>
  )
}
